const selectors = [
  '[aria-invalid="true"]',
  '[aria-errormessage]',
].join(', ');

export default function (container) {
  const errors = container.querySelectorAll(selectors);

  if (errors[0]) {
    errors[0].focus();
  }
}
